import { animated } from 'react-spring'
import styled from 'styled-components'

type ModalWrapperProps = {
  open: boolean
}

type ModalContainerProps = {
  width?: string
}

export const ModalWrapper = styled.div.attrs({
  tabIndex: -1
})<ModalWrapperProps>`
  position: absolute;
  top: 0;
  left: 0;

  display: ${({ open }) => (open ? 'block' : 'none')};

  height: 100%;
  width: 100%;

  border: none;

  background: rgba(159, 159, 159, 0.25) !important;
  backdrop-filter: blur(5px) !important;

  z-index: ${({ theme }) => theme.zIndex.modal};
`

export const ModalContainer = styled(animated.div)<ModalContainerProps>`
  position: relative;

  margin: 15vh auto 0;
  padding: ${({ theme }) => `${theme.spacings[8]} ${theme.spacings[16]}`};
  padding-top: ${({ theme }) => `${theme.spacings[14]}`};

  width: ${(props) => (props.width ? props.width : '70vw')};
  max-height: 90vh;

  background-color: ${({ theme }) => theme.colors.white};

  overflow-y: auto;
  overflow-x: hidden;

  box-shadow: 0 3px 6px 0 rgba(1, 45, 79, 0.16);
  border-radius: 24px;
`

export const ModalCloseButton = styled.button`
  position: absolute;
  top: ${({ theme }) => theme.spacings[12]};
  right: ${({ theme }) => theme.spacings[12]};

  color: ${({ theme }) => theme.colors.black};

  line-height: 0;

  border: none;
  background-color: transparent;

  svg {
    width: 20px;
  }

  :hover {
    filter: brightness(0.8);
  }

  :focus {
    outline: 1px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: 2px;
  }
`

export const ModalBackButton = styled.button`
  position: absolute;
  top: ${({ theme }) => theme.spacings[7]};
  left: ${({ theme }) => theme.spacings[6]};

  color: ${({ theme }) => theme.colors.primary};

  line-height: 0;

  border: none;
  background-color: transparent;

  svg {
    width: 30px;
  }

  :hover {
    filter: brightness(0.8);
  }

  :focus {
    outline: 1px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: 2px;
  }
`

type ModalHeaderContainerProps = {
  separator: boolean
}

export const ModalHeaderContainer = styled.header<ModalHeaderContainerProps>`
  display: flex;
  justify-content: center;

  border-bottom: ${({ theme, separator }) =>
    separator ? `1px solid ${theme.colors.warmGreyThree}` : 'none'};
`

export const ModalBodyContainer = styled.div`
  padding: ${({ theme }) => theme.spacings[2]};
`
